var map = {
	"./AboutPage/acc_about.jpg": 7293,
	"./AboutPage/acc_about2.jpg": 8499,
	"./AboutPage/acc_about3.jpg": 3734,
	"./AboutPage/acc_about4.jpg": 6429,
	"./AboutPage/acc_about5.jpg": 8336,
	"./Acc_logo/Asset 6 SVG FILE - Symbol Black.svg": 5873,
	"./Acc_logo/Asset 6 SVG FILE - Symbol Blue.svg": 5612,
	"./Acc_logo/Asset 6 SVG FILE - Symbol colors.svg": 2124,
	"./Acc_logo/Asset 6 SVG FILE - Symbol trans.svg": 9750,
	"./Acc_logo/Logo_Trans.svg": 3245,
	"./Acc_logo/Logo_colors _Trans.svg": 2636,
	"./Acc_logo/acc-logo.jpg": 4792,
	"./Acc_logo/built-in-canada.svg": 5794,
	"./Acc_logo/canlogo.svg": 1498,
	"./Acc_logo/logo_blue.svg": 7253,
	"./Acc_logo/logo_blue1.svg": 3278,
	"./Acc_logo/logo_blue_full.svg": 6855,
	"./BusinessDevelopmentManager.jpg": 4165,
	"./BusinessLogo.png": 1804,
	"./CheckCircleBlueIcon.svg": 8754,
	"./CheckCircleIcon.svg": 9150,
	"./Client-signup-img.png": 5347,
	"./Cost-effective Growth.png": 9987,
	"./Dark_Gray_twitter_logo.png": 1351,
	"./Establish Trust.png": 3580,
	"./Expand your Reach.png": 4527,
	"./Expert-signup-img.jpg": 5616,
	"./Increase Visibility.png": 6455,
	"./IndividualLogo.png": 9271,
	"./QuotationIconNew.png": 646,
	"./ReadyToStart.jpeg": 8978,
	"./RedCrossIcon.png": 2179,
	"./SearchLogo.png": 3930,
	"./Sing-up-page-background.png": 5115,
	"./SparkleIcon.svg": 2204,
	"./Utilize AI Technology.png": 829,
	"./Work Flexibly.png": 7719,
	"./a-icon.jpg": 4122,
	"./about.png": 8748,
	"./archiveIcon.svg": 4092,
	"./attachment.svg": 6796,
	"./backendDev.jpg": 5578,
	"./bg-img-men.jpeg": 8896,
	"./bg-img-women.jpg": 6421,
	"./bg-main.png": 2490,
	"./bg.jpg": 5150,
	"./black-logo.svg": 3072,
	"./blog-default-img.png": 8253,
	"./blog-fallback.jpg": 1476,
	"./blue_background.png": 5600,
	"./blurtext.gif": 5410,
	"./bookkeepingImg.png": 4222,
	"./budget-8314862_1280.png": 4317,
	"./business-strategy-manager.jpeg": 8274,
	"./calculaterLogo.png": 4932,
	"./categoryImages/Accounting_trans_icon.png": 9144,
	"./categoryImages/Bookkeeping icon.png": 2941,
	"./categoryImages/Business_tran_icon.png": 8392,
	"./categoryImages/Payroll_trans_icon.png": 6494,
	"./categoryImages/accounting copy.png": 1374,
	"./categoryImages/accounting.png": 585,
	"./categoryImages/bookkeeping_trans.png": 3607,
	"./categoryImages/buiness_trans_icon.png": 9756,
	"./categoryImages/business.png": 6376,
	"./categoryImages/individule_trans_icon.png": 36,
	"./categoryImages/payroll.png": 9059,
	"./categoryImages/tax.png": 1491,
	"./categoryImages/tax_trans_icone.png": 929,
	"./ceo-picture.png": 5105,
	"./cfo-picture.png": 5335,
	"./chart.png": 9635,
	"./clientSignupChoice.jpg": 3975,
	"./client_home_video_thumbnail.png": 1299,
	"./client_home_video_thumbnails.jpg": 8852,
	"./close.svg": 7733,
	"./components/AdjustIconForNavigation": 3437,
	"./components/AdjustIconForNavigation.jsx": 3437,
	"./components/ArchiveForNavigation": 6395,
	"./components/ArchiveForNavigation.jsx": 6395,
	"./components/PaymentIconForNavigation": 4654,
	"./components/PaymentIconForNavigation.jsx": 4654,
	"./components/ProfileIconForNavigation": 701,
	"./components/ProfileIconForNavigation.jsx": 701,
	"./coupon_code.png": 1529,
	"./creditIcon.png": 1715,
	"./cto-picture.png": 5310,
	"./default-avatar.jpeg": 3589,
	"./docx-placeholder.png": 7501,
	"./doller.png": 9789,
	"./dpd.jpg": 3547,
	"./email-logo.jpg": 9795,
	"./email-logo.png": 2939,
	"./email-logo.svg.png": 9731,
	"./excel-placeholder-1.png": 7028,
	"./excel-placeholder.png": 7214,
	"./exclamation-round-icon.svg": 4085,
	"./experience_modal_bulb.png": 4895,
	"./expert.png": 2579,
	"./expert/help.svg": 6323,
	"./expert/icon1.svg": 7074,
	"./expert/icon2.svg": 2113,
	"./expert/icon3.svg": 9872,
	"./expert/img1.svg": 9420,
	"./expert/img2.svg": 8447,
	"./expert/img3.svg": 5870,
	"./expert/img4.svg": 5777,
	"./expertIcon.png": 7152,
	"./expertIndexBg.jpeg": 6095,
	"./expertIndexBg.jpg": 6898,
	"./expertIndexBgWhite.jpg": 1203,
	"./expertSignupChoice.jpg": 1978,
	"./expert_home_video_thumbnail.png": 7424,
	"./expert_home_video_thumbnail_2.jpeg": 6372,
	"./flagIcon.png": 3190,
	"./frontendDeveloper.jpg": 2617,
	"./futuremeetingicon.png": 784,
	"./gloab.svg": 4688,
	"./google-maps.svg": 3554,
	"./google_logo.svg": 6800,
	"./howItWork.png": 745,
	"./howItWork2.png": 847,
	"./howItWork3.png": 1830,
	"./howItWork4.png": 4873,
	"./image-placeholder.png": 1140,
	"./infoIcon.svg": 2764,
	"./job-fee-card/Screenshot 2025-07-10 105913.png": 6609,
	"./job-fee-card/accounting.png": 912,
	"./job-fee-card/bookkeeping.png": 3139,
	"./job-fee-card/business-financing.png": 9761,
	"./job-fee-card/business-financing.svg": 1803,
	"./job-fee-card/businessanalysis.png": 7627,
	"./job-fee-card/payrollmanagement.png": 3317,
	"./job-fee-card/taxservices.png": 5292,
	"./linked-in-about-page.png": 8936,
	"./linkedIn.svg": 4985,
	"./linkedin.png": 5405,
	"./loader.gif": 7049,
	"./location.png": 4318,
	"./logo2.png": 8886,
	"./logo3.svg": 1125,
	"./mail.svg": 2558,
	"./mailIcon.png": 8473,
	"./mail_logo.png": 5208,
	"./marketingManager.jpeg": 1407,
	"./messageBoxImg.png": 9702,
	"./notification-icon.svg": 8632,
	"./ocmanager.jpg": 9340,
	"./openai-icon.svg": 3057,
	"./paymentIcon.svg": 1416,
	"./paymentInfoIcon.jpeg": 3147,
	"./pdf-placeholder.png": 4857,
	"./pencilImage.png": 437,
	"./people.png": 7634,
	"./practice-expansion.png": 7080,
	"./prince_img.png": 2864,
	"./profileIcon.svg": 2901,
	"./profile_image_placeholder.png": 3160,
	"./profile_image_placeholder_transparent.png": 9783,
	"./profile_placeholder.png": 1658,
	"./qotationIcon.png": 8043,
	"./questionIcon.png": 8172,
	"./questions_icons/Bookkeeping.png": 6350,
	"./questions_icons/accounting.png": 1335,
	"./questions_icons/business.png": 3058,
	"./questions_icons/business1.png": 7857,
	"./questions_icons/business_financing.png": 5308,
	"./questions_icons/calculator.png": 8796,
	"./questions_icons/chart.png": 6746,
	"./questions_icons/dollar.png": 7838,
	"./questions_icons/individual.png": 1017,
	"./questions_icons/search.png": 6392,
	"./questions_icons/staff.png": 6200,
	"./ratingIcon.png": 9331,
	"./ready_to_get_started_client.jpeg": 3158,
	"./recommend-expert-modal-avatar.png": 7656,
	"./red-x-icon.svg": 195,
	"./relationship-manager.png": 4387,
	"./removed_bg_man.png": 1904,
	"./removed_bg_women.png": 4410,
	"./requestIcon.png": 9503,
	"./searchIcon.svg": 8592,
	"./signupemaillinkedinimg.png": 8580,
	"./signupimg.png": 9402,
	"./site-logo-white.png": 124,
	"./site-logo.png": 7868,
	"./star.svg": 8775,
	"./starImg.jpg": 5850,
	"./starting-a-practice.png": 7023,
	"./successicon.svg": 4807,
	"./text-icon.svg": 2592,
	"./thread-logo.png": 3723,
	"./thread.svg": 71,
	"./thumbImg.jpeg": 575,
	"./twitter.svg": 6072,
	"./usersIcon.png": 3520,
	"./video-camera-icon.png": 3932,
	"./video.png": 4170,
	"./warningImg.jpeg": 8931,
	"./whats_next_accept.png": 3769,
	"./whats_next_book.png": 2474,
	"./whats_next_green_tick.png": 3489,
	"./whats_next_message.png": 7588,
	"./whats_next_search.png": 1281,
	"./white-logo.svg": 1958,
	"./x-logo.svg": 6391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;